const staticText = {
  modalTitle: 'Disable SSO',
  description: 'This will permanently delete the connection and you will have to set up SSO again. Enter your organization name below to confirm.',
};

export default staticText;
